module.exports = __webpack_public_path__ + "static/media/hu.fcbb8be9.svg";